<template>
    <modal @close="$emit('close')" :show-title="true" :size="'medium'">
        <div slot="header">
            <h5 class="modal-title">{{$t('premi_accumulati')}}</h5>
        </div>
        <div slot="body">
            <div class="container">
                <div class="row-sezione text-center">
                    <button
                        type="button"
                        class="a1 text-left p-0 border-0 bg-transparent w-100 mb-4"
                        v-for="reward in this.rewards"
                        :key="reward.id"
                        @click="applyReward(reward)"
                    >
                        <div class="codici-sconto p-3">
                            {{$t('premio')}}:<br>
                            <b class="f2">
                                <inc-reward-name :reward="reward" :type="reward.tipo"/>
                            </b>
                            <br>
                            <span class="color">
                                {{$t("valido_dal")}}
                                {{moment(reward.data_inizio).format('DD/MM/YYYY')}}
                                {{$t("al")}}
                                {{moment(reward.data_scadenza).format('DD/MM/YYYY')}}
                            </span>
                        </div>
                    </button>
                </div>
            </div>
        </div>
    </modal>
</template>

<script>
    import {mapGetters} from 'vuex';

    import Modal from '../../partials/Modal';
    import IncRewardName from '../../fidelity/partials/IncRewardName';

    export default {
        name: "ModalRewards",
        components: {IncRewardName, Modal},
        props: ['rewards'],
        methods: {
            applyReward: function (reward) {
                this.$emit('apply', {
                    rewardId: reward && reward.id ? reward.id : null
                });
            }
        },
        computed: {
            ...mapGetters('restaurant', {
                locale_currency: 'localeCurrency'
            })
        }
    }
</script>
